(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-payment-icons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('svg[aria-labelledby="pi-bancontact"]').forEach(function(svg) {
      var suffix = Math.random().toString(36).slice(2, 7);
      svg.querySelectorAll('[id]').forEach(function(el) {
        var old = el.id;
        svg.querySelectorAll('[fill="url(#' + old + ')"]').forEach(function(ref) {
          ref.setAttribute('fill', 'url(#' + old + '_' + suffix + ')');
        });
        el.id = old + '_' + suffix;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-product-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSwatches(root) {
      if (!root || root.__swatchesInited) return;
      root.__swatchesInited = true;

      var list = root.querySelector('.custom-product-swatches__list');
      if (!list) return;

      var mobileBehavior = (root.dataset.mobileBehavior || 'scrollable').toLowerCase();
      var showMoreEnabled = root.dataset.showMoreEnabled !== 'false';

      // When the +1 overlay is disabled, scroll the active swatch into view and center it on mobile.
      if (!showMoreEnabled && mobileBehavior === 'scrollable' && window.matchMedia('(max-width: 749px)').matches) {
        var activeLink = list.querySelector('.custom-product-swatches__link--active');
        var activeItem = activeLink ? activeLink.closest('.custom-product-swatches__item') : null;
        if (activeItem) {
          var listRect = list.getBoundingClientRect();
          var itemRect = activeItem.getBoundingClientRect();
          list.scrollLeft += itemRect.left - listRect.left - ((list.clientWidth - itemRect.width) / 2);
        }
      }

      // Hover: update color name
      var colorNameEl = root.querySelector('.custom-product-swatches__color-name');
      if (colorNameEl) {
        var originalColor = colorNameEl.textContent;
        Array.from(
          list.querySelectorAll('.custom-product-swatches__link:not(.custom-product-swatches__link--active)')
        ).forEach(function (link) {
          var color = link.getAttribute('aria-label');
          link.addEventListener('mouseenter', function () {
            colorNameEl.textContent = color;
          });
          link.addEventListener('mouseleave', function () {
            colorNameEl.textContent = originalColor;
          });
        });
      }

      // Show more: reveal hidden swatches on overlay click
      var moreBtn = root.querySelector('.custom-product-swatches__more');
      if (moreBtn) {
        moreBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          Array.from(list.querySelectorAll('.custom-product-swatches__item.is-hidden')).forEach(function (li) {
            li.classList.remove('is-hidden');
          });
          moreBtn.remove();
        });
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.custom-product-swatches').forEach(initSwatches);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var target = /** @type {Element} */ (event.target);
      var el = target.querySelector('.custom-product-swatches');
      if (el) initSwatches(el);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-size-table"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-table-block')) {
    customElements.define('size-table-block', class extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('dialog');
        this.openBtn = this.querySelector('[data-open-dialog]');
        this.closeBtns = this.querySelectorAll('[data-close-dialog]');

        this.openBtn.addEventListener('click', () => this.dialog.showModal());

        this.closeBtns.forEach(btn => {
          btn.addEventListener('click', () => this.close());
        });

        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.close();
        });

        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close();
        });
      }

      close() {
        this.dialog.classList.add('closing');
        this.dialog.addEventListener('animationend', () => {
          this.dialog.close();
          this.dialog.classList.remove('closing');
        }, { once: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
